import { mergeAttributes, Node } from '@tiptap/core';
import { nanoid } from 'nanoid';
import updateNestedAttribute from 'pages/revisions-module/template-editor/editors/template/extensions/utils/update-nested-attribute';
import unwrapAncestorNode from 'pages/revisions-module/template-editor/editors/template/extensions/utils/unwrap-ancestor-node';

export interface DeviceLoopOptions {}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    deviceLoop: {
      setDeviceLoop: () => ReturnType;
      unsetDeviceLoop: () => ReturnType;
      setDeviceLoopUnique: (unique: boolean) => ReturnType;
    };
  }
}

export const DeviceLoop = Node.create<DeviceLoopOptions>({
  name: 'deviceLoop',
  content: 'block+',
  group: 'block',
  defining: true,

  addAttributes() {
    return {
      'data-id': { default: nanoid() },
      'data-unique': { default: 'false' },
    };
  },

  parseHTML() {
    return [{ tag: 'div.device-loop' }];
  },

  renderHTML({ HTMLAttributes, node }) {
    const attrs = {
      'data-iterator': 'devices',
      'data-id': node.attrs['data-id'],
      'data-unique': node.attrs['data-unique'],
    };

    return [
      'div',
      mergeAttributes({ class: 'device-loop' }, HTMLAttributes),
      ['div', { class: 'loop-block-start', ...attrs }],
      ['div', { class: 'device-loop-body', ...attrs }, 0],
      ['div', { class: 'loop-block-end', ...attrs }],
    ];
  },

  addCommands() {
    return {
      setDeviceLoop:
        () =>
        ({ commands }) => {
          return commands.wrapIn(this.name);
        },
      unsetDeviceLoop: () => (props) => unwrapAncestorNode(props, this.name),
      setDeviceLoopUnique:
        (unique: boolean) =>
        ({ commands }) =>
          updateNestedAttribute(commands, 'deviceLoop', 'data-unique', unique ? 'true' : 'false'),
    };
  },
});
